function roundMoney(value, decimals = 4) {
  const amount = Number(value || 0);
  const factor = 10 ** decimals;
  return Math.round(amount * factor) / factor;
}

export default {
  computed: {
    previewDocumentTotals() {
      return this.computeDocumentTotalsPreview({
        lines: this.lines,
        quantityKey: this.lineQuantityKey,
        defaultVatRate: this.document.default_vat_rate,
        extraCosts: this.extraCosts || [],
      });
    },
  },
  methods: {
    roundMoney(value, decimals = 4) {
      return roundMoney(value, decimals);
    },
    computeLineNetFromUnit(line, quantityKey) {
      const qty = Number(line[quantityKey] ?? line.quantity ?? 0);
      const unitCost = Number(line.unit_cost_net || 0);
      return roundMoney(qty * unitCost);
    },
    computeDocumentTotalsPreview({ lines, quantityKey, defaultVatRate, extraCosts = [] }) {
      let totalNet = 0;
      let totalVat = 0;
      const defaultVat = Number(defaultVatRate ?? 0);

      (lines || []).forEach((line) => {
        if (!line.stock_product_id) {
          return;
        }

        const lineNet = roundMoney(
          line.line_total_net != null && line.line_total_net !== ""
            ? line.line_total_net
            : this.computeLineNetFromUnit(line, quantityKey)
        );
        const vatRate = Number(line.vat_rate ?? defaultVat);
        const lineVat = roundMoney((lineNet * vatRate) / 100);

        totalNet += lineNet;
        totalVat += lineVat;
      });

      (extraCosts || []).forEach((extra) => {
        const amountNet = Number(extra.amount_net || 0);
        const vatRate = Number(extra.vat_rate ?? defaultVat);
        totalNet += amountNet;
        totalVat += roundMoney((amountNet * vatRate) / 100);
      });

      totalNet = roundMoney(totalNet);
      totalVat = roundMoney(totalVat);

      return {
        total_net: totalNet,
        total_vat: totalVat,
        total_gross: roundMoney(totalNet + totalVat),
      };
    },
  },
};
